<template>
    <b-modal
      centered
      :hide-footer="true"
      modal-class="c-wrap"
      dialog-class="md_modal_dialog_full4"
      content-class="c-content"
      header-class="popup_header1"
      body-class="c-body container"
      :visible="visible"
      @show="onShowModal"
      @hide="onCancel"
    >
      <template #modal-header style="width: 100%;">
        <span style="margin: auto">{{$t('more.inquire')}}</span>
<!--        <b-button @click="onCancel" class="btn-cross" variant="white">-->
<!--          <b-icon icon="x"></b-icon>-->
<!--        </b-button>-->
        <b-img class="mo_close_btn"  @click="onCancel" :src="require('../../../assets/image/ic_close2.png')" style="margin-right:0px;"/>
      </template>

      <div class="leftright">
        <c-select
        v-if="variant == 'create'"
        style="width: 120px; height:40px; font-size: 16px; font-family: 'KoreanGD15R';text-align: left;"
        :options="typeOptions"
        v-model="type"
        />
        <b-form-input v-else type="text" readonly class="input input-text name_wrapper"
                      style="background-color: white"
                      :value="$c.INQUIRE_CATEGORY[type]">
        </b-form-input>

        <div class="center">
          <b-form-input v-if="myinfo.isAdmin() && this.inquire_idx > 0" type="text" readonly class="input input-text name_wrapper" style="margin-right: 10px;"
                        :value="user_phone"></b-form-input>
          <b-form-input type="text" readonly class="input input-text name_wrapper"
                        :value="user_name"></b-form-input>
        </div>
      </div>
      <b-form-input type="text" class="input input-text-title" style="margin-top: 15px"
                    v-model="title"
                    :readonly="variant == 'detail'"
                    :placeholder="$t('community.title_placeholder')"/>
      <b-form-textarea
        class="input input-text-title"
        :readonly="variant == 'detail'"
        :style="{marginTop: '8px', padding: '8px', height: myinfo.isAdmin()? '350px':'350px'}"
        v-model="content"
        :placeholder="$t('community.content_placeholder')"/>
      <div class="leftright" style="margin-top: 13px; margin-bottom: 0">
        <template v-if="variant == 'create'">
          <div class="answer_text" v-if="this.inquire_idx > 0">{{$t('inquire.answer')}}</div>
          <div v-else />
          <md-single-check-box
            :label="$t('inquire.secret')"
            v-model="secret"
            variant="red"/>
        </template>
        <template v-else-if="this.answer != ''">
          <div class="answer_text">{{$t('inquire.answer')}}</div>
          <md-single-check-box
            :label="$t('inquire.secret')"
            :readonly="true"
            variant="red"/>
        </template>
      </div>
        <div style="padding-bottom: 5em;"  v-if="inquire_idx > 0 && variant == 'create'" >
          <b-form-textarea
            class="textarea_wrapper answer_content"            
            v-model="answer"
            :readonly="!this.myinfo.isAdmin()"
            :placeholder="$t('inquire.answer_placeholder')"/>
          <div  v-if="myinfo.isAdmin()">
            <b-button @click="onSaveAnswer" class="save_btn">
              {{$t('community.regist')}}
            </b-button>
          </div>
        </div>

        <div style="padding-bottom: 5em;"  v-if="answer!=''&& variant =='detail'" >
          <b-form-textarea
            class="textarea_wrapper answer_content"            
            v-model="answer"            
            readonly />
          <div  v-if="myinfo.isAdmin()">
            <b-button @click="onSaveAnswer" class="save_btn">
              {{$t('community.regist')}}
            </b-button>
          </div>
        </div>
      <!--
      <template v-if="answer!=''&& variant =='detail'">
        <div
          class="textarea_wrapper_detail"
          style="margin-top:8px; padding: 8px; line-height: 24px"
          v-html="replaceEnter(answer)"
          readonly/>
      </template>-->
      <div class="c-footer" v-if="variant == 'create'">
        <b-button  @click="inquire_idx == 0 ? onCancel(): onDelete()" class="footer-btn" style="background: #cacbcd">
          {{inquire_idx == 0? $t('common.cancel') : $t('common.delete')}}</b-button>
        <b-button @click="onComplete" variant="primary" class="footer-btn">
          {{inquire_idx == 0?$t('common.complete1') : $t('common.modify') }}</b-button>
      </div>
    </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
const $u = require('util');

import MdSingleCheckBox from "../mf/MdSingleCheckBox";
import CSelect from "../CSelect";

export default {
  name: "InquireCreatePopup",
  components: {MdSingleCheckBox, CSelect},
  props:{
    visible:{type:Boolean},
    info:{type:Object},
    variant:{type:String, default:'detail'}
  },
  data() {
    return {
      u:$u,
      Utils:Utils,
      inquire_idx: 0,
      type: this.$c.INQUIRE_TYPE.REGISTER,
      title: '',
      user_phone: Utils.formatPhoneNumber(this.myinfo.user_phone),
      content: '',
      answer:'',
      secret:'N',
      user_name:this.myinfo.name,
    }
  },
  methods:{
    onShowModal(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },
    onSaveAnswer(){
      if (this.answer == '') {
        Utils.toast(this, this.$t('inquire.answer_placeholder'));
        return;
      }

      Utils.requestPost(
        this.$c.API.Inquire.sendInquireAnswer,
        {
          inquire_idx: this.inquire_idx,
          answer:this.answer,
        }
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.$emit('edit', this.answer);
          Utils.toast(this, this.$t('inquire.answer_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onComplete(){

      if (this.title == '') {
        Utils.toast(this,this.$t("community.title_placeholder"));
        return;
      }
      if (this.content == '') {
        Utils.toast(this, this.$t("community.content_placeholder"));
        return;
      }

        Utils.requestPost(
          this.inquire_idx == 0 ? this.$c.API.Inquire.addInquire : this.$c.API.Inquire.updateInquire,
          {
            inquire_idx:this.inquire_idx,
            type: this.type,
            title: this.title,
            content: this.content,
            secret:this.secret,
          }
        ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.$emit('add');
              this.onCancel();
              Utils.toast(this, this.$t('common.save_success'))
            } else {
              Utils.toast(this, result.msg);
            }
        });
    },

    onDelete(){
      Utils.showConfirm(
        this,
        this.$t('inquire.delete_confirm'),
      ).then(val=>{
        if (val){
          Utils.requestPost(
            this.$c.API.Inquire.removeInquire,
            {
              idx_list: JSON.stringify([this.inquire_idx]),
            },
          ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.$emit('delete');
              this.onCancel();
              Utils.toast(this, this.$t('common.delete_success'));
            } else {
              Utils.toast(this, result.msg);
            }
          });
        }
      });
    },

    initState(){
        this.inquire_idx =  0;
        this.type= this.$c.INQUIRE_TYPE.REGISTER;
        this.title= '';
        this.user_phone= '';
        this.content= '';
        this.answer = '';
        this.user_name = this.myinfo.name;
        this.secret= false;
    },

    onShow(){
      if (this.info == null){
      } else {
          this.inquire_idx = this.info.f_idx;
          this.type = this.info.f_type;
          this.title = this.info.f_title;
          this.user_phone = Utils.formatPhoneNumber(this.info.f_user_phone);
          this.content = this.info.f_content;
          this.user_name= this.info.f_user_name;
          this.answer = this.info.f_answer;
          this.secret = this.info.f_secret;
      }
    },

    onCancel(){
      if(window.history.state == "forward")
        window.history.back();
      this.initState();
    },

    replaceEnter(text){
      return text.replace(/\n/g, "<br>");
    },
     },

  watch: {
    visible: function (){
      if (this.visible)
        this.onShow();
    },

    // secret_state(){
    //   this.secret = this.secret_state == true ? 'Y' : 'N';
    // },
    // secret(){
    //   this.secret_state = this.secret == 'Y'? true : false;
    // }
  },
  computed:{
    typeOptions(){
      return this.$c.INQUIRE_CATEGORY;
    },
  },
  mounted() {
    this.user_phone= Utils.formatPhoneNumber(this.myinfo.user_phone);
    this.myinfo.loadInfo();
  },
  inject: ['eventBus'],
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";

.setting_btn {
  align-items: center;
  justify-content: center;
  background-color: $c_457fff;
  border-radius: 5px;
  width: 83px;
  height: 32px;
  font-size: $fs_12;
  padding: 0;
}

.add_btn {
  align-items: center;
  justify-content: center;
  background-color: #0840ba!important;
  border-radius: 4px;
  width: 83px;
  height: 32px;
  font-size: $fs_12;
  padding: 0;
  margin-top: 5px;
}

.save_btn{
  height: 36px;
  width: 85px;
  margin-top: 5px;
  background-color: #0840ba;
  border-radius: 4px;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  color: white;
  float: right;
}

.answer_text{
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
}

.disable{
  background-color: #ddddde!important;
}

::placeholder{
  color: #666666;
}

.c-footer{
  //width: 100%;
  width: 480px;
  height: 50px;
  display: flex;
  //position: fixed;
  position: absolute;
  bottom: 0;  
  left: -2px;
}

.footer-btn{
  background: $c_457fff;
  flex: 1;
  margin: 0;
  border-radius: 0;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.leftright{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.disable{
  background-color: #cacbcd;
}

.textarea_wrapper{
  border-width: 2px;
  border-color: #eeeeef;
  border-radius: 3px;
  padding:0 8px;
  height: 99px;
  background-color: #f8f8f8;
}

.textarea_wrapper_detail{
  @extend .textarea_wrapper;
  border-style: solid;
  height: 210px!important;
  min-height: 30px;
  background-color: white;
  font-size: $fs_20;
  font-family: $korean_gd_14_r;
}

.name_wrapper{
  text-align:center;
  height: 40px;
  background-color: #eeeeef;
  width: 140px;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
}

//.tooltip-body{
//  background: rgba(105, 105, 105, .9);
//}

.answer_content{
  margin-top: 13px; 
  padding: 8px;   
  height: 200px; 
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/InquireCreatePopup.vue